import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const EmptyContainer = styled.div `
  padding: ${themeGet('spacing.5xl')};
  padding-top: ${themeGet('spacing.md')};
`;
